import { mapWithConcurrency } from '@/shared/utils/map-with-concurrency.util';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { cidDescriptionOptions, normalizeCidCodes } from './cid-descriptions';

export function useCidDescriptions(codes: readonly string[]) {
  const queryClient = useQueryClient();
  const uniqueCodes = normalizeCidCodes(codes).sort();
  return useQuery({
    queryKey: ['services', 'cids', 'analysis-descriptions', uniqueCodes],
    queryFn: async (): Promise<Record<string, string | null>> => {
      const results = await mapWithConcurrency(uniqueCodes, 5, code =>
        queryClient.fetchQuery(cidDescriptionOptions(code))
      );
      return Object.fromEntries(
        uniqueCodes.map((code, index) => {
          const result = results[index];
          return [code, result.status === 'fulfilled' ? result.value : null];
        })
      );
    },
    enabled: uniqueCodes.length > 0,
    // Reconsulta falhas ao reabrir; sucessos reutilizam o cache por código.
    staleTime: 0,
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
}
